import { render, staticRenderFns } from "./InputGroupSubLabel.vue?vue&type=template&id=5041d654&"
import script from "./InputGroupSubLabel.vue?vue&type=script&lang=js&"
export * from "./InputGroupSubLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports